import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space, Button } from 'antd';
import React, { useContext, useMemo, useState } from 'react';

import { GET_SERVICES_IMPORT_TEMPLATE_ENDPOINT } from '@app/constants';
import { useExportToExcel } from '@app/hooks';
import { HeaderContext } from '@app/providers';
import type { NClientServices } from '@app/types';
import { openImportTemplateFile } from '@app/utils';

import type { NServicesSorting } from '@pages/Clients/ServicesSorting/ServicesSorting.types';
import { createServicesSortingMenuItems } from '@pages/Clients/ServicesSorting/utils/createServicesSortingMenuItems';

import type { MenuProps } from 'antd';

type MobileHeaderDropdownProps = {
  services: NServicesSorting.ServiceRow[];
  hasUserRightToExport: boolean;
  hasUserRightToImport: boolean;
  hasUserRightToCreateCategory: boolean;
  hasUserRightToCreateService: boolean;
};

export const MobileHeaderDropdown: React.FC<MobileHeaderDropdownProps> = ({
  services,
  hasUserRightToExport,
  hasUserRightToImport,
  hasUserRightToCreateCategory,
  hasUserRightToCreateService,
}) => {
  const [loader, setLoader] = useState(false);
  const { isLoading: isHeaderLoading } = useContext(HeaderContext);

  const { exportToExcelByIds } = useExportToExcel({
    setLoader,
  });

  const items: MenuProps['items'] = useMemo(
    () =>
      createServicesSortingMenuItems({
        services,
        hasUserRightToExport,
        hasUserRightToImport,
        hasUserRightToCreateCategory,
        hasUserRightToCreateService,
        exportToExcelByIds: (ids) =>
          exportToExcelByIds(ids as NClientServices.Service[]),
        importInputId: 'UpdateByExcelForDevices',
        includeCreationActions: true,
        onExportTemplateClick: () =>
          openImportTemplateFile(GET_SERVICES_IMPORT_TEMPLATE_ENDPOINT),
      }) || [],
    [
      exportToExcelByIds,
      hasUserRightToCreateCategory,
      hasUserRightToCreateService,
      hasUserRightToExport,
      hasUserRightToImport,
      services,
    ]
  );

  if (!items || !items.length) {
    return null;
  }

  return (
    <Dropdown className="header-buttons__tablet" menu={{ items }}>
      <Space>
        <Button
          type="primary"
          icon={<DownOutlined />}
          loading={loader || isHeaderLoading}
        />
      </Space>
    </Dropdown>
  );
};
